<template>
  <div class="ai_chat">
    <WordDictM class="d-lg-none" v-if="dickData" v-on:closeDict="closeDickALL" :content="dickData.ductWord" />
    <div class="d-flex">
      <TalkingIdol class="talkingIdol d-none d-xl-block" :selectedIdx="TalkingIdolIdx"  />
      <div class="flex-1 d-flex">
        <div class="swiper_item flex-1">
          <div class="slider-banner position-relative">
            <div class="swiper" ref="mySwiper">
              <div v-show="isBegin" class="swiper-item">
                <Orally_speaking_header :isBegin="isBegin" :selectedStep="0" v-on:reStart="reStart" />

                <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent">
                  <div v-if="chatObj.length > 0" >
                    <div v-for="(item, index) in chatObj" :key="index">
                      <RobotDialogue :isSelectedType="false" :itemData="item" :isBegin="isBegin" :selectedStep="selectedStep" class="mb-3" v-if="item.role === 'robot'" v-on:selectAnswer="selectAnswer" v-on:selectType="selectType" />
                      <SelfDialogue :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                      <RobotDialogue :isSelectedType="true" :selectedAns="selectedAns" :selectedAns2="selectedAns2" v-if="index === chatObj.length - 1 && (selectedAns && selectedAns2)" v-on:selectType="selectType" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-show="!isBegin" class="swiper-item">
                <Orally_speaking_header :isBegin="isBegin" :selectedStep="0" v-on:reStart="reStart" :selectedAns="selectedAns" :selectedAns2="selectedAns2"  />

                <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent1">
                  <div v-if="follow_upObj.length > 0">
                    <div v-for="(item, index) in follow_upObj" :key="index">
                      <RobotDialogue :selectedStep="0" :itemData="item" class="mb-3" v-if="item.role === 'robot'" />
                      <SelfDialogue :selectedStep="0" :itemData="item" class="mb-3" v-if="item.role === 'self'" />
                    </div>
                  </div>
                </div>

                <div class="follow-btn d-flex justify-content-center w-100 align-items-center text-lg">
                  <a @click="generateSentence" class="pointer flex-1 d-flex bg-chat-purple font-bold text-white justify-content-center align-items-center">
                    <img src="@/assets/image/ai/icon_re.png" alt="" class="mr-1"><p>繼續練習 Continue</p>
                  </a>
                  <a @click="toSlide(1)" class="pointer flex-1 d-flex bg-chat-green font-bold text-white justify-content-center align-items-center py-1">
                    <p>對話練習 Conversation</p><img src="@/assets/image/ai/arrow_R.png" alt="" class="ml-1">
                  </a>
                </div>
              </div> -->
              <div v-show="!isBegin" class="swiper-item">
                <div class="w-100 position-relative d-flex">
                <div class="w-100">
                  <Orally_speaking_header :isBegin="isBegin" :selectedStep="1" v-on:reStart="reStart" :selectedAns="selectedAns" :selectedAns2="selectedAns2" :isDisabledInput="isDisabledInput" />

                  <div class="chat-content bg-white p-3 w-100 smooth-scroll" ref="chatContent2">

                    <div v-if="conversationObj.length > 0">
                      <div v-for="(item, index) in conversationObj" :key="index">
                        <RobotDialogue :chatHistory="chatHistory[index]" :itemIdx="index" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'robot'" v-on:endTyped="scrollToBottom" v-on:emitTalkIdolIdx="emitTalkIdolIdx" :isDisabledInput="isDisabledInput" />
                        <SelfDialogue :chatHistory="chatHistory[index]" :theme="theme" :context="context" :selectedStep="1" :itemData="item" class="mb-3" v-if="item.role === 'self'" :isDisabledInput="isDisabledInput" />
                      </div>
                    </div>
                  </div>

                  <div class="chat-button d-flex justify-content-center w-100 align-items-center">
                    <a class="ai-suggest-button pointer tooltip-outer d-none d-lg-inline-block" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                      <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isTranslateBtn">
                      <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="w-100 h-auto d-inline-block" v-if="isTranslateBtn">
                      <span class="tooltiptext_left">{{ $t('AiHome.chat.chinese_input') }}</span>
                    </a>
                    <a class="ai-suggest-button pointer tooltip-outer d-none d-lg-inline-block" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                      <img src="@/assets/image/ai/AI_A.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isAiSuggest">
                      <img src="@/assets/image/ai/AI_A_active.png" alt="" class="w-100 h-auto d-inline-block" v-if="isAiSuggest">
                      <span class="tooltiptext">{{ $t('AiHome.chat.ai_suggest') }}</span>
                    </a>
                    <SpeechRecognition v-on:speechCountDown="speechCountDown" v-on:emitSpeechRecognition="emitSpeechRecognition" v-if="isOpenKeyboard" :isDisabledInput="isDisabledInput" />

                    <div class="chat-button-input d-flex align-items-center flex-1 p-2 pr-4 bg-white" v-if="isOpenKeyboard">
                      <a v-if="!isSpeechRecognition" class="keyboard-btn notOpenKeyboard d-block mr-2 p-2 px-3">
                        <img src="@/assets/image/ai/notOpenKeyboard.png" alt="" class="">
                      </a>
                      <p class="mr-2 p-2 text-sm" v-if="isSpeechRecognition">{{ speechCount }}s</p>
                      <input ref="input3" :disabled="remainPoints < 1 || isDisabledInput" type="text" class="w-100 border-0 focus:outline-none" v-model="selfText" @keyup.enter="inputText3" :placeholder="!isDisabledInput ? $t('AiHome.chat.placeholder_active') : $t('AiHome.chat.placeholder_disabled')">
                      <a class="pointer ml-2 tooltip-outer d-inline-block" @click="inputText3()" :class="{ 'opacity-50': remainPoints < 1 || isDisabledInput }"><img src="@/assets/image/ai/submit_icon.png" alt="" class="">
                        <span class="tooltiptext">{{ $t('AiHome.chat.submit') }}</span>
                      </a>
                    </div>

                  </div>
                  <div class="d-flex aiSuggestDialogue">
                    <a class="translate-suggest-button mr-1 d-mr-2 ai-suggest-button pointer tooltip-outer d-lg-none" @click="toggleTranslateBtn()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                      <img src="@/assets/image/ai/translate_btn_off.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isTranslateBtn">
                      <img src="@/assets/image/ai/translate_btn_on.png" alt="" class="w-100 h-auto d-inline-block" v-if="isTranslateBtn">
                      <span class="tooltiptext_left">{{ $t('AiHome.chat.chinese_input') }}</span>
                    </a>
                    <a class="mr-1 d-mr-2 ai-suggest-button pointer tooltip-outer d-lg-none" @click="toggleAISuggest()" v-if="isOpenKeyboard" :class="{ 'opacity-50': !lastChatResult || remainPoints < 1 }">
                      <img src="@/assets/image/ai/AI_A.png" alt="" class="w-100 h-auto d-inline-block" v-if="!isAiSuggest">
                      <img src="@/assets/image/ai/AI_A_active.png" alt="" class="w-100 h-auto d-inline-block" v-if="isAiSuggest">
                      <span class="tooltiptext">{{ $t('AiHome.chat.ai_suggest') }}</span>
                    </a>

                    <AiSuggestDialogue :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isAiSuggest" />
                    <TranslateDialogue :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="pt-1 pb-4 flex-1" v-if="isOpenKeyboard && isTranslateBtn" v-on:swal_failPopAPI="swal_failPopAPI" />
                  </div>
                  <!-- <AiSuggestDialogue :session_id="session_id" :theme="theme" :context="context" :context2="context2" :lastChatResult="lastChatResult" class="mt-2" v-if="isOpenKeyboard && isAiSuggest" /> -->

                </div>

              </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a class="tips_btn d-inline-block pointer mt-5 tooltip-outer" @click="toggleTips">
            <img src="@/assets/image/ai/tips_btn.png" alt="" class=" object-contain">
            <span class="tooltiptext">{{ $t('AiHome.rule.Friendly_Reminder') }}</span>
          </a>
          <testingToolsSWAL />
        </div>
      </div>
      <!-- <div class="swiper_rule">
        <Rule />
      </div> -->
    </div>
  </div>
</template>

<script>
import api from '@/store/api'
import Orally_speaking_header from '@/components/AiHelper/chat/orally_speaking_header'
import RobotDialogue from '@/components/AiHelper/chat/robotDialogue'
import SelfDialogue from '@/components/AiHelper/chat/selfDialogue'
import AiSuggestDialogue from '@/components/AiHelper/chat/aiSuggestDialogue'
import TranslateDialogue from '@/components/AiHelper/chat/translateDialogue'
import SpeechRecognition from '@/components/AiHelper/chat/SpeechRecognition'
import allJs from '@/components/AiHelper/all.js'
import Rule from '@/components/AiHelper/rule.vue'
import Bus from '@/components/AiHelper/bus.js'
import WordDictM from '@/components/AiHelper/WordDictM'
import TalkingIdol from '@/components/AiHelper/chat/TalkingIdol'
import { mapGetters } from 'vuex'
import testingToolsSWAL from '@/components/AiHelper/chat/testingToolsSWAL'
export default {
  name: 'chat_ai',
  components: {
    RobotDialogue,
    SelfDialogue,
    AiSuggestDialogue,
    TranslateDialogue,
    Orally_speaking_header,
    SpeechRecognition,
    Rule,
    WordDictM,
    TalkingIdol,
    testingToolsSWAL
  },
  data () {
    return {
      pageTitle: '',
      chatJSon: null,
      selectedStep: 0,
      isOpenKeyboard: true,
      isTips: false,
      isDictionary: false,
      isBegin: true,
      isAiSuggest: false,
      isTranslateBtn: false,

      recorder: null,
      playTime: 0,
      timer: null,
      src: null,
      isRecorder: false,

      session_id: null,

      selfText: '',

      selectedAns: null,
      selectedAns2: null,

      chatObj: [],

      follow_upObj: [],

      conversationObj: [],

      element2OffsetHeight: null,

      speechCount: null,
      isSpeechRecognition: false,

      carousel_left: 0,

      lastChatResult: null,

      bannerOption: {
        slidesPerView: 1,
        centeredSlides: true,
        watchOverflow: true,
        loop: false,
        allowTouchMove: false,
        effect: 'slide'
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      },

      isGettingChatsCreate: false,

      chatHistory: [],

      audio_id: '',

      dickData: null,

      prompt_id: null,
      TalkingIdolIdx: 0,

      isDisabledInput: false,
      recordScene: null
    }
  },
  mixins: [
    allJs
  ],
  computed: {
    ...mapGetters([
      'remainPoints'
    ]),
    theme () {
        if ((this.selectedAns && this.selectedAns2 && this.selectedStep === 0) || this.selectedAns && this.selectedAns2 && this.selectedStep === 1) {
          return this.selectedAns2.theme
        } else if (this.$route.name === 'viewChat' && this.recordScene) {
          return this.recordScene.theme
        }
      // if (this.selectedAns && this.selectedAns2 && this.selectedStep === 0) {
      //   return this.selectedAns2.theme
      // } else if (this.selectedAns && this.selectedAns2 && this.selectedStep === 1) {
      //   return this.selectedAns2.theme
      // }
      return ''
    },
    context () {
      if ((this.selectedAns && this.selectedAns2 && this.selectedStep === 0) || (this.selectedAns && this.selectedAns2 && this.selectedStep === 1)) {
        return this.selectedAns2.context
      } else if (this.$route.name === 'viewChat' && this.recordScene) {
        return this.recordScene.context
      }
      // if (this.selectedAns && this.selectedAns2 && this.selectedStep === 0) {
      //   return this.selectedAns2.context
      // } else if (this.selectedAns && this.selectedAns2 && this.selectedStep === 1) {
      //   return this.selectedAns2.context
      // }
      return ''
    },
    context2 () {
      if (this.selectedAns && this.selectedAns2 && this.selectedStep === 0) {
        return this.selectedAns2.context2
      } else if (this.selectedAns && this.selectedAns2 && this.selectedStep === 1) {
        return this.selectedAns2.context2
      }
      return ''
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  created () {
    // this.getCategories()
    this.initFunc()
  },
  mounted () {
    this.getBus()
  },
  watch: {
    'conversationObj': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.scrollToBottom()
        }
      },
      deep: true,
      immediate: true
    },
    'selfText': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal && newVal && this.$route.name !== 'ChatAIJp') {
          this.selfText = newVal.replace(/[^\w\s',\uFF0C\u002E\u003F\uFF1A\u003A\/\-\!]/g, '')
        }
      },
      immediate: true
    },
  },
  updated () {
  },
  methods: {
    initFunc () {
      if (this.$route.name === 'chatAI') {
        this.getCategories()
      } else if (this.$route.name === 'ChatAIJp') {
        this.getCategories()
      } else {
        this.$route.name === 'viewChat' ? this.initViewSetting() : null
      }
    },
    closeDickALL () {
      this.dickData = null
      Bus.$emit('closeDickALL')
    },
    getCategories () {
      // 場景與動作
      let path = `/ai/categories/${this.$route.params.promptId}`
      if (this.$route.name === 'ChatAIJp'){
        path = path + '/?lang=ja-JP'
      }
      let obj = { role: 'robot', text: this.$t('AiHome.chat.choose_topic'), options: null, isLoading: true }
      this.chatObj.push(obj)

      const options = { headers: {'showLoading': false }}

      api.get(path, options)
      .then((res) => {
        this.prompt_id = res.data.prompt_id
        this.chatJSon = res.data.data
        this.pageTitle = res.data.name

        let index = this.chatObj.findIndex(x => x.isLoading === true)

        this.chatObj[index].isLoading = false
        this.chatObj[index].options = res.data.data
      })
      .catch((err) => {
        console.log(err)
      })
    },
    // view
    async initViewSetting () {
      this.$route.query.conversation_id ? this.session_id = this.$route.query.conversation_id : null

      await this.getHistory()

      this.isDisabledInput = true
      this.isBegin = false

      this.$nextTick(() => {
        this.selectedStep = 1
      })
    },

    emitSpeechRecognition (payload) {
      if (payload) {
        this.selfText = this.selfText + payload.result

        this.audio_id = payload.id

        this.$refs.input3.focus()
      }
    },

    async chatsCreate () {
      // 會話開始
      let path = `/ai/generate/${this.prompt_id}`
      if (this.$route.name === 'ChatAIJp'){
        path = `/ai/generate/018970f3-cabd-4925-b697-bed8e37b13be`
      }
      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      this.conversationObj.push(obj)

      let body = {
        theme: this.theme,
        context: this.context
      }
      body.chat_name = `${this.$t('AiHome.chat.speaking_practice')}(${this.pageTitle} /${this.selectedAns.name}/${this.selectedAns2.name})`

      const options = { headers: {'showLoading': false }}
      this.isGettingChatsCreate = true
      await api.post(path, body, options)
      .then((res) => {
        this.$store.dispatch('getRemainPoints')
        this.session_id = res.data.session

        this.setDataWithPractice(res.data.result)

        this.isBegin = false
        this.selectedStep = 1

        this.isGettingChatsCreate = false
      })
      .catch((err) => {
        console.log(err)
      })
    },

    generateSentence () {
      // 實用句
      let path = `/ai/generate/sentence`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      this.follow_upObj.push(obj)
      const options = { headers: {'showLoading': false }}
      api.post(path, {
        theme: this.theme,
        context: this.context
      }, options)
      .then((res) => {
        this.$store.dispatch('getRemainPoints')
        this.setDataWithFollow(res.data.result)
          this.$nextTick(() => {
          this.scrollToBottom()
        })
      })
      .catch(() => {
      })
    },

    chatsContinue (text) {
      // 繼續對話
      let path = `/ai/chats/${this.session_id}`

      let obj = { role: 'robot', text: '', ttsUrl: null, translate: null, isLoading: true }
      this.conversationObj.push(obj)
      const options = { headers: {'showLoading': false }}
      api.post(path, {
        content: text,
        audio: this.audio_id
      }, options)
      .then((res) => {
        this.$store.dispatch('getRemainPoints')
        this.setDataWithPractice(res.data.result)

        this.audio_id = ''
      })
      .catch(() => {
        this.conversationObj.pop()
      })
    },

    getHistory () {
      let path = `ai/chats/${this.session_id}/history`
      const options = { headers: {'showLoading': false }}
      api.get(path, options)
      .then((res) => {
        this.chatHistory = res.data.records

        if (res.data.theme && res.data.context) {
          this.recordScene = {
            theme: res.data.theme,
            context: res.data.context
          }
        }
        this.$route.name === 'viewChat' ? this.initConversationObj(res.data.records) : null
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async initConversationObj (records) {
      this.$route.name === 'viewChat' ? this.$store.dispatch('isLoading', true) : null
      let array = []
      for (let item of records) {
        if (item.role === 'assistant' ) {
          array.push({
            isLoading: false,
            role: 'robot',
            text: item.content,
            translate: this.theme && this.context && this.$route.name !== 'viewChat' ? await this.get_Translate_Dialog(this.theme, this.context, item.content): '',
            audio: item.audio,
            ttsUrl: ''
          })
        }
        if (item.role === 'user' ) {
          array.push({
            role: 'self',
            text: item.content
          })
        }
      }

      this.conversationObj = array
      this.$route.name === 'viewChat' ? this.$store.dispatch('isLoading', false) : null
    },
    async setDataWithFollow (result) {
      let index = this.follow_upObj.findIndex(x => x.isLoading === true)

      this.follow_upObj[index].isLoading = false
      this.follow_upObj[index].text = result
      this.follow_upObj[index].ttsUrl = await this.getTTSUrl('female', result)
      this.follow_upObj[index].translate = null
    },

    async setDataWithPractice (result) {
      this.lastChatResult = result
      let index = this.conversationObj.findIndex(x => x.isLoading === true)

      this.conversationObj[index].isLoading = false
      this.conversationObj[index].text = result
      this.conversationObj[index].ttsUrl = await this.getTTSUrl('female', result)
      this.conversationObj[index].translate = await this.get_Translate_Dialog(this.theme, this.context, result)

      this.$nextTick(() => {
        this.scrollToBottom()
        this.getHistory()
      })
    },

    reStart () {
      this.isBegin = true
      this.selectedStep = 0
      this.isAiSuggest = false
      this.isTranslateBtn = false

      this.selectedAns = null
      this.selectedAns2 = null

      this.chatObj = this.$options.data().chatObj
      this.follow_upObj = []
      this.conversationObj = this.$options.data().conversationObj

      this.$forceUpdate()
      this.initFunc()

      this.$store.dispatch('setPlayBackRate', 1)
      this.$store.dispatch('toggleSubtitle', true)
    },

    scrollToBottom () {
      if (this.chatObj.length > 0 || this.conversationObj.length > 0) {
        const element = this.$refs.chatContent
        const element1 = this.$refs.chatContent1
        const element2 = this.$refs.chatContent2

        if (element && element.scrollHeight > element.offsetHeight) {
          element.scrollTop = element.scrollHeight
        }
        if (element1 && element1.scrollHeight > element1.offsetHeight) {
          element1.scrollTop = element1.scrollHeight
          this.$nextTick(() => {
            element1.scrollTop = element1.scrollHeight
          })
        }
        if (element2 && element2.scrollHeight > element2.offsetHeight) {
          element2.scrollTop = element2.scrollHeight
          this.$nextTick(() => {
            element2.scrollTop = element2.scrollHeight
          })
        }

      }

    },

    selectAnswer (payload) {
      if (payload.name !== '我有其他想法') {
        if (payload.items) {
          this.selectedAns = payload

          this.chatObj.push({ role: 'self', text: payload.name })
          this.chatObj.push({ role: 'robot', text: this.$t('AiHome.chat.what_to_do_in_topic', { topic: payload.name }), options: payload.items })

          if (this.selectedAns2) {
            this.selectedAns2 = null
          }
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        } else {
          if (payload.pre_name !== this.selectedAns.name) {
            let index = this.chatJSon.findIndex(x => x.name === payload.pre_name)
            this.selectedAns = this.chatJSon[index]
          }
          this.selectedAns2 = payload

          this.chatObj.push({ role: 'self', text: payload.name })

          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }
      } else {
        this.$refs.input1.focus()
      }
    },

    inputText () {
      if (this.selfText) {
        if (selectAnswer.items) {
          this.selectedAns = {
            name: this.selfText,
            name_en: this.selfText,
            theme_practical: this.selfText,
            theme_chat: this.selfText
          }

          this.chatObj.push({ role: 'self', text: selectAnswer.name })
          this.chatObj.push({ role: 'robot', text: this.$t('AiHome.chat.what_to_do_in_topic', { topic: selectAnswer.name }), options: selectAnswer.items })

          if (this.selectedAns2) {
            this.selectedAns2 = null
          }
        } else {
          this.selectedAns2 = {
            name: this.selfText,
            name_en: this.selfText,
            theme_practical2: this.selfText,
            theme_chat2: this.selfText,
            context_practical: this.selfText,
            context_chat: this.selfText
          }

          this.chatObj.push({ role: 'self', text: selectAnswer.name })
        }
      }
    },

    inputText2 () {},

    inputText3 () {
      if (this.selfText.trim().length > 0 && this.remainPoints > 0 || !this.isDisabledInput) {
        this.conversationObj.push({ role: 'self', text: this.selfText })

        this.chatsContinue(this.selfText)

        this.selfText = ''

        this.isAiSuggest = false

        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }

      if (this.remainPoints < 1) {
        this.swal_failPopPoints(this.$t('AiHome.swal.insufficient_points'))
      }
    },

    selectType (payload) {
      if (this.remainPoints > 0) {
        const myName1 = () => {
          return new Promise(async(resolve) => {
            let isStart = await this.swal_startCheck()

            if (isStart) {
              this.isBegin = false
              resolve('isBegin')
            }
          })
        }

        Promise.race([myName1()])
        .then(() => {
          if (payload === 'record') {
            this.selectedStep = 0
            this.generateSentence()
          } else if (payload === 'practice') {
            this.selectedStep = 1
            !this.isGettingChatsCreate ? this.chatsCreate() : null
          }
        })
      } else {
        this.swal_failPopPoints(this.$t('AiHome.swal.insufficient_points'))
      }
    },

    onPageChange (currentPage) {
      if (currentPage === 0) {
        if (this.follow_upObj.length < 1 && this.conversationObj.length > 0) {
          this.generateSentence()
        }
      } else {
        if (this.follow_upObj.length > 0 && this.conversationObj.length < 1) {
          this.chatsCreate()
        }
      }
    },

    speechCountDown (payload) {
      this.isSpeechRecognition = payload.isSpeechRecognition
      this.speechCount = payload.count
    },

    toggleTranslateBtn () {
      if (this.isDisabledInput)return

      if (this.lastChatResult && this.remainPoints > 0) {
        this.isTranslateBtn = !this.isTranslateBtn
        this.isAiSuggest = false
      } else if (this.remainPoints < 1) {
        this.isTranslateBtn = false
        this.swal_failPopPoints(this.$t('AiHome.swal.insufficient_points'))
      } else if (!this.isAvailableInSchool) {
        this.isTranslateBtn = false
        this.swal_failPopPoints(this.$t('AiHome.swal.points_or_expired'))
      }
    },

    toggleAISuggest () {
      if (this.lastChatResult && this.remainPoints > 0) {
        this.isAiSuggest = !this.isAiSuggest
        this.isTranslateBtn = false
      } else if (this.remainPoints < 1) {
        this.swal_failPopPoints(this.$t('AiHome.swal.insufficient_points'))
      }
    },

    swal_startCheck () {
      return this.$swal({
        html: `<p>${this.$t('AiHome.swal.current_points_html', { points: this.remainPoints })}</p><p>${this.$t('AiHome.swal.practice_deduct_desc')}</p>`,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: this.$t('AiHome.swal.got_it'),
        title: this.$t('AiHome.rule.Friendly_Reminder'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
        .then((result) => {
          if (result.isConfirmed === true) {
            return true
          }
        }
      )
    },
    swal_failPopPoints (text) {
      let defaultTitle = text ?  `<h3>${text}</h3><p>${this.$t('AiHome.swal.contact_cs')}</p>` : `<h3>${this.$t('AiHome.swal.generate_fail')}</h3><p>${this.$t('AiHome.swal.generate_fail_msg')}</p>`
      this.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t('AiHome.common.confirm'),
        title: this.$t('AiHome.rule.Friendly_Reminder'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'save_check my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },
    swal_failPopUp (text) {
      let defaultTitle = text ?  `<h3>${text}</h3><p>${this.$t('AiHome.swal.contact_cs')}</p>` : `<h3>${this.$t('AiHome.swal.generate_fail')}</h3><p>${this.$t('AiHome.swal.generate_fail_msg')}</p>`
      this.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t('AiHome.common.confirm'),
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },
    swal_failPopAPI () {
      this.$swal({
        html: `<p>${this.$t('AiHome.swal.please_reinput')}</p>`,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: this.$t('AiHome.swal.got_it'),
        title: this.$t('AiHome.rule.Friendly_Reminder'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
        .then((result) => {
          if (result) {
            this.isDisabledInput = false
          }
        }
      )
    },
    getBus () {
      Bus.$on('getDickData', (data) => {
        this.dickData = data
      })
    },

    emitTalkIdolIdx (payload) {
      this.TalkingIdolIdx = payload
    },

    toggleTips () {
      const htmlText = `
        <h6 id="swal-points" class="mb-1 font-bold text-lg">${this.$t('AiHome.swal.current_points_html', { points: this.remainPoints })}</h6>
        <h6 class="font-bold text-lg mb-3">${this.$t('AiHome.swal.tips_html_2')}</h6>
        <h6 class="font-bold text-lg">${this.$t('AiHome.swal.tips_html_3')}</h6>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_4', { img1: `<img src="${require('@/assets/image/ai/mic_C.png')}" class="inline-block icon-img mx-1">`, img2: `<img src="${require('@/assets/image/ai/submit_icon.png')}" class="inline-block icon-img mx-1">` })}</p>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_5', { img1: `<img src="${require('@/assets/image/ai/AI_A.png')}" class="inline-block icon-img mx-1">` })}</p>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_6', { img1: `<img src="${require('@/assets/image/ai/translate_btn_off.png')}" class="inline-block icon-img mx-1">` })}</p>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_7', { img1: `<img src="${require('@/assets/image/ai/btn_AItalk_voice.png')}" class="inline-block icon-img mx-1">` })}</p>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_8', { img1: `<img src="${require('@/assets/image/ai/btn_AItalk_correct.png')}" class="inline-block icon-img mx-1">` })}</p>
        <p class="mb-2">${this.$t('AiHome.swal.tips_html_9')}</p>
      `
      return this.$swal({
        html: htmlText,
        showDenyButton: false,
        focusConfirm: false,
        confirmButtonText: this.$t('AiHome.common.close'),
        title: this.$t('AiHome.rule.Friendly_Reminder'),
        position: window.innerWidth < 768 ? 'top' : 'center',
        customClass: {
          title: 'text-white text-2xl swal_tips',
          popup: 'p-0',
          header: 'justify-content-center align-items-center ',
          htmlContainer: 'my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-deny'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ai_chat {
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
  .swiper_item {
    min-height: 600px;
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 8);
      padding: 0.5rem;
    }
  }
  .swiper_rule {
    width: 100%;
    @media (min-width: 640px) {
      width: calc(100% / 12 * 4);
      padding: 0.5rem;
    }
  }
  .opacity-50 {
    opacity: 0.5;
  }
  font-family: x-locale-heading-primary, zillaslab, Palatino, "Palatino Linotype", x-locale-heading-secondary, 'Source Han Serif SC', "STZhongsong", "Source Han Sans CN", 'PingFang SC', 'Myriad Pro', 'Hiragino Sans GB', "SimHei";
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  // padding-left: 5em;
  // padding-right : 5em;
  // @media (max-width: 1024px) {
  //   padding-left: 0;
  //   padding-right : 0;
  // }
  .VueCarousel-navigation-next {
    width: 68px;
    height: 538px;
    background: linear-gradient(272.05deg, #D4D5E1 1.95%, #FFFFFF 42.8%);
  }
  .follow-btn {
    a {
      height: 3.5em;
      &:hover {
        text-decoration: none !important;
      }
    }
  }
}
  .tips-btns {
    top: 0%;
    right: 0;
      padding-top: 82px;
    }
  .chat-content {
    height: calc(60vh);
    overflow-y: scroll;
    overflow-x: hidden;
    @media (max-width: 640px) {
      height: calc(50vh);
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
    }

    ::-webkit-scrollbar {
      width: 6px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    .tips-content {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .tips-shadow-bg {
        width: 8%;
        background:rgba(0, 0, 0, 0.7);
      }
      .tips-right {
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }
  .ai-suggest-button {
    width: 3rem !important;
    height: 3rem !important;
    margin-right: .25rem !important;
  }
  .chat-button {
    padding-top: .75rem !important;
    padding-bottom: .75rem !important;

    .chat-button-input  {
      border-radius: 53px;
      img {
        height: 28px;
        width: auto;
      }
    }
  }

  .keyboard-btn {
    img {
      height: 25px;
      width: auto;
    }
  }
  .notOpenKeyboard {
  }
  .openKeyboard {
    img {
      height: 54px;
      width: auto;
    }
  }
  .microphone-btn {
    background-color: #5A5D9B;
    padding: .8rem 6.5rem;
    border-radius: 53px;
    img {
      height: 26px;
      width: auto;
    }
  }
  .aiSuggestDialogue {
    min-height: 52px;
    @media (max-width: 1024px) {
      min-height: 172px;
    }
  }
</style>
